import React, { useContext, useState } from "react";
import classnames from "classnames";
import { patchJsonRequest } from "Helpers/ApiRequest";
import { DietaryEntities } from "Helpers/DataDefinitions/Dietaries";
import Item from "./Item";
import Modal from "./Modal";
import { BrandContext, useBrandStyleClasses } from "./BrandContext";
import { Price } from "./Item";

export const PromotionCard = ({ item }) => {
  const { isPlayful, isElegant, isSimple, isBrutalist, ...venueBrand } =
    useContext(BrandContext);

  const brandStyleClasses = useBrandStyleClasses();

  return (
    <div className="relative overflow-x-auto antialiased">
      <div
        className={brandStyleClasses(
          "aspect-w-7 aspect-h-10 w-256 space-x-8 overflow-hidden",
          {
            brutalist: "shadow-brutalist border-2 border-neutral-500",
            playful: "rounded-xl",
            simple: "rounded shadow",
            elegant: "shadow",
          }
        )}
      >
        {item.heroImageUrl && item.heroImageUrl != "/assets/missing.png" ? (
          <img
            src={item.heroImageUrl}
            className={classnames("object-cover object-center", {
              "rounded-xl shadow": isPlayful,
              "rounded shadow": isSimple,
              "": isElegant,
            })}
            alt="Food"
          />
        ) : (
          <div className="w-full h-full bg-sogui-brand-200 pattern-hideout" />
        )}
      </div>

      <div className="absolute bottom-0 w-full">
        <div
          className={brandStyleClasses(
            "bg-[linear-gradient(to_bottom,#ffffff00,#000000)]",
            {
              playful: "rounded-xl",
              simple: "rounded",
            }
          )}
        >
          <div className="flex flex-row justify-between text-white px-16 py-16">
            <p className="text-xs font-bold">{item.itemName}</p>
            <p className="text-xs font-bold">
              <Price value={item.salePrice} priceUnit={null} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PromotionDetails = ({ item }) => {
  return (
    <div className="z-30 w-full flex flex-col">
      <div className="aspect-w-7 aspect-h-10 antialiased rounded-t-lg overflow-y-hidden">
        <img src={item.heroImageUrl} className="object-cover" alt="Food" />
      </div>

      <div className="bg-white p-16 space-y-16 rounded-b-lg">
        <Item
          item={{
            ...item,
            name: item.itemName,
            detail: item.marketingBlurb,
            salesPrice: item.salePrice,
          }}
          pricingType={"simple"}
          itemDescription={"short_description"}
        />

        <div className="flex justify-end space-x-8">
          {item.dietaries
            .map((dietary) => DietaryEntities[dietary].Icon)
            .map((Icon) => (
              <div className="rounded-full bg-white text-venue-brand">
                <Icon className="h-24" />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

const Promotions = ({ items, previewMenu }) => {
  const { isPlayful, isElegant, isSimple, isBrutalist, ...venueBrand } =
    useContext(BrandContext);

  const [openPromotion, setOpenPromotion] = useState(null);

  const mapPromotionalItem = ({
    heroImage,
    itemCravings,
    itemDietaries,
    itemMarketingBlurb,
    itemTaxInclusivePrice,
    ...rest
  }) => ({
    heroImageUrl: heroImage,
    cravings: itemCravings,
    dietaries: itemDietaries,
    marketingBlurb: itemMarketingBlurb,
    salePrice: itemTaxInclusivePrice,
    ...rest,
  });

  const handleClick = async (item) => {
    setOpenPromotion(item);
    await patchJsonRequest({
      url: `/marketing_api/marketing_activations/${item.uuid}/record_engagement`,
    });
  };

  return (
    <div className="pt-12 space-y-16">
      <div
        className={classnames("flex-1", {
          "uppercase font-light text-center": isElegant,
          "uppercase font-bold": isBrutalist,
          "border-b-2 mb-4  border-venue-brand font-medium text-lg": isSimple,
          "font-semibold text-xl text-venue-brand": isPlayful,
        })}
      >
        <p>Popular items & specials</p>
      </div>
      <div className="flex flex-row overflow-x-auto overflow-y-hidden snap-x space-x-12">
        {Object.values(items)
          .map(mapPromotionalItem)
          .map((item) => (
            <div
              onClick={() => handleClick(item)}
              className="snap-center mx-auto"
            >
              <PromotionCard item={item} />
            </div>
          ))}

        <div className="absolute top-0 left-0 right-0">
          <div className="relative p-16 w-full h-full md:h-auto">
            {!previewMenu && openPromotion && (
              <Modal
                onClose={() => {
                  setOpenPromotion(null);
                }}
              >
                <PromotionDetails item={openPromotion} />
              </Modal>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Promotions;
